import React, { Fragment, useEffect } from "react";

import { useHistory } from "react-router-dom";

// componente fake utilizzato solo per il redirect su home: passando dal componente intermedio si riesce a far ricaricare home anche se si è già sulla home
// sarà superfluo con il passaggio a react-router v6
function HomeContainer() {

    const history = useHistory();

    useEffect(() => {
        history.push("/home");
    }, [history]);

    return (
        <Fragment />
    )
}

export default HomeContainer;
